import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import BodyRegular from 'components/Typography/BodyRegular';

export default function Suboption({ link, children }: {
  link: string;
  children: any;
}) {
  const location = useLocation();
  const active = location.pathname.startsWith(link);

  return (
    <Link to={link} className={`sidebar-suboption-link ${active ? 'active' : ''}`}>
      <BodyRegular>{ children }</BodyRegular>
    </Link>
  );
}
